module.exports = __webpack_public_path__ + "static/media/veiculo.291258df.glb";